<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_550')}}</div>
    <div slot="body">
      <a-alert class="mb-2" :message="$t('scope.text_551')" banner />
      <vxe-grid
        :size="tableConfig.size"
        ref="emailTable"
        class="mt-4"
        :loading="loading"
        :data="list"
        :columns="columns"
        :edit-config="tableConfig.editConfig"
        @edit-closed="editClosedEvent()" />
      <div v-show="!isUpdate" class="email-add"><span class="add" @click="addHandle(-1)">{{$t('scope.text_552')}}</span></div>
    </div>
    <div slot="footer">
      <a-button @click="cancelDialog">{{$t('scope.text_457')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BindGoogleEmailDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      isUpdate: false,
      tableConfig: {
        size: 'mini',
        editConfig: { trigger: 'manual', mode: 'row', showIcon: false, autoClear: false },
      },
      form: {
        fc: this.$form.createForm(this),
      },
      list: [],
      customerId: '', // 目前只支持一个云账号
      columns: [
        {
          field: 'email',
          title: this.$t('scope.text_553'),
          minWidth: 100,
          editRender: { name: 'input', attrs: { type: 'email', tooltip: this.$t('scope.text_554') } },
        },
        {
          title: this.$t('scope.text_555'),
          width: 100,
          showOverflow: true,
          visible: !this.readyOnly,
          fixed: 'right',
          slots: {
            default: ({ row, column }) => {
              if (this.$refs.emailTable.isActiveByRow(row)) {
                return [
                  <span class="add" onClick={ e => this.saveTableRowEvent(row) }>保存</span>,
                  <span class="del" onClick={ e => this.cancleTableRowEvent(row) }>取消</span>,
                ]
              } else {
                return [
                  <span class="del" onClick={ e => this.deleteTableRowEvent(row) }>删除</span>,
                ]
              }
            },
          },
        },
      ],
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  created () {
    this.fetchEmail()
  },
  methods: {
    async editClosedEvent () {
      this.isUpdate = false
      await this.fetchEmail()
    },
    async addHandle (row) {
      this.isUpdate = true
      const record = {
        port: 200,
        eip: 100,
        snapshot: 100,
        bucket: 50,
        object_cnt: 10000,
        object_gb: 10240,
        rds: 50,
        cache: 50,
        loadbalancer: 50,
        isNew: true,
      }
      const { row: newRow } = await this.$refs.emailTable.insertAt(record, row)
      await this.$refs.emailTable.setActiveRow(newRow)
    },
    async saveTableRowEvent (row) {
      await this.$refs.emailTable.clearActived()
      const params = {
        owner: row.email,
      }
      try {
        await this.doUpdate(params, 'add-owner')
      } catch (error) {
        throw error
      } finally {
        this.fetchEmail()
      }
    },
    async deleteTableRowEvent (row) {
      const params = {
        owner: row.email,
      }
      try {
        await this.doUpdate(params, 'revoke-owner')
      } catch (error) {
        throw error
      } finally {
        this.fetchEmail()
      }
    },
    async cancleTableRowEvent (row) {
      const xTable = this.$refs.emailTable
      await xTable.clearActived()
      await xTable.revertData(row)
    },
    doUpdate (data, action) {
      return new this.$Manager('cloudsupplier_customers').performAction({ id: this.customerId, action, data })
    },
    async fetchEmail () {
      const { data: { data = [] } } = await new this.$Manager('cloudsupplier_customers').list()
      this.list = []
      data.forEach(item => {
        if (this.params.data[0].id === item.id) {
          if (item.metadata && item.metadata.project_owners && item.metadata.project_owners.length > 0) {
            const emails = item.metadata.project_owners.includes(',') ? item.metadata.project_owners.split(',') : item.metadata.project_owners
            if (R.type(emails) === 'Array') {
              emails.forEach(emailItem => {
                this.list.push({
                  id: item.id,
                  email: emailItem,
                })
              })
            } else {
              this.list.push({
                id: item.id,
                email: emails,
              })
            }
          } else {
            this.list = []
          }
          if (item.provider.toLowerCase() === 'google') {
            this.customerId = item.id
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.email-add {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #e8eaec;
  border-top: none;
}
.add {
  display: inline-block;
  margin-right: 6px;
  color: #007fdf;
  cursor: pointer;
}
.del {
  display: inline-block;
  cursor: pointer;
}
</style>
